var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0067B9",
  fillRule: "nonzero",
  d: "M20 4h-2V2h-2v2H8V2H6v2H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 16H4v-8h16v8zm0-10H4V6h2v2h2V6h8v2h2V6h2v4z"
})));
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4NCiAgICA8cGF0aCBmaWxsPSIjMDA2N0I5IiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0yMCA0aC0yVjJoLTJ2Mkg4VjJINnYySDRhMiAyIDAgMCAwLTIgMnYxNGEyIDIgMCAwIDAgMiAyaDE2YTIgMiAwIDAgMCAyLTJWNmEyIDIgMCAwIDAtMi0yem0wIDE2SDR2LThoMTZ2OHptMC0xMEg0VjZoMnYyaDJWNmg4djJoMlY2aDJ2NHoiLz4NCjwvc3ZnPg0K";
export { SvgIconCalendar as ReactComponent };